import { SaleScanntechAuditOrigin } from '@gipi-sale/scanntech-audit/enums/scanntech-audit-origin.enum';
import { SaleScanntechAuditStatus } from '@gipi-sale/scanntech-audit/enums/scanntech-audit-status.enum';
import { GIPIBaseAbstractFilterModel } from '@gipi-shared/models/base-abstract-filter.model';
import { GIPIUuid } from '@gipisistemas/ng-core';

export class SaleScanntechDetailedAuditFilterDTO extends GIPIBaseAbstractFilterModel {

    dailyClosingId: GIPIUuid;

    originList: SaleScanntechAuditOrigin[];

    promotionId: GIPIUuid;

    resendRequestId: GIPIUuid;

    saleId: GIPIUuid;

    scanntechIntegrationAuditId: GIPIUuid;

    statusList: SaleScanntechAuditStatus[];

}
